import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import LetrusLoader from 'components/LetrusLoader';
import {Button, Modal} from 'letrus-ui';
import styles from './SubmitCompositionModal.module.scss';

export interface SubmitCompositionModalProps {
  onClose(): void;
  id: string;
  onClick(): void;
  loading: boolean;
  hasReviewError?: boolean;
}

function SubmitCompositionModal({
  id,
  loading,
  onClose,
  onClick,
  hasReviewError,
}: SubmitCompositionModalProps): JSX.Element {
  return (
    <Modal id={id} title={loading ? 'Carregando...' : 'Sucesso!'}>
      <div className={styles.container}>
        <hr />

        {loading ? (
          <div className={styles.loading}>
            <LetrusLoader />

            <div className={styles.contentLoading}>
              <FontAwesomeIcon icon="clock" color="#4574B9" />
              <strong>Carregando...</strong>
            </div>

            <span>
              Estamos corrigindo sua redação, isso pode levar alguns segundos!
              Em breve você terá acesso à sua devolutiva.
            </span>
          </div>
        ) : (
          <>
            {hasReviewError ? (
              <div className={styles.reviewErrorContent}>
                <FontAwesomeIcon icon="clock" size="2x" color="#ffbf00" />
                <span>
                  Sua correção está demorando um pouco mais do que o esperado!
                  Retorne em breve para conferir sua devolutiva
                </span>
              </div>
            ) : (
              <>
                <span className={`${styles.icon} ${styles.success}`}>
                  <FontAwesomeIcon icon="check" size="2x" color="#fff" />
                </span>
                <p className={styles.successMessage}>
                  Sua redação foi enviada com sucesso!
                </p>
              </>
            )}

            <Button onClick={hasReviewError ? onClose : onClick}>
              {hasReviewError ? 'Voltar' : 'Continuar'}
            </Button>
          </>
        )}
      </div>
    </Modal>
  );
}

export default SubmitCompositionModal;
